import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { getRoutes } from 'constants/nav';
import { ROUTES } from 'constants/routes';
import { useUserStore } from 'stores/user';

export const useNavRedirect = (when: boolean): void => {
  const navigate = useNavigate();
  const user = useUserStore(state => state.user);

  useEffect(() => {
    if (!when) return;
    navigate(getRoutes(user)[0]?.href ?? ROUTES.HOME, { replace: true });
  }, [when, user, navigate]);
};
